<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M8.7507 7.1265H19.31M8.7507 12H19.31M8.7507 16.8735H19.31M4.68945 7.1265H4.69758M4.68945 12H4.69758M4.68945 16.8735H4.69758" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
